import { Component, Optional, Self } from '@angular/core';
import { BlockButton, ButtonColor, ButtonPosition, ButtonType } from '@src/app/@shared/models/step.model';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';
import { ButtonPadding, ButtonVariant } from '@app/components/button/button.component';
import { NgControl } from '@angular/forms';
import { CourseContentService } from '@app/courseContent/courseContent.service';
import { PdfGeneratorService } from '@shared/services/pdfGenerator/pdfGenerator.service';
import { PlRouter } from '@shared/services/pl-router.service';

@Component({
  selector: 'pl-block-button',
  templateUrl: './block-button.component.html',
})
export class BlockButtonComponent extends BlockAbstractComponent<BlockButton, null> {
  public buttonVariant: ButtonVariant = ButtonVariant.white;

  public manuallyDisableButton: boolean = false;

  protected readonly ButtonPadding: typeof ButtonPadding = ButtonPadding;
  protected readonly ButtonPosition: typeof ButtonPosition = ButtonPosition;

  constructor(
    @Optional() @Self() public override controlDir: NgControl,
    protected override courseContentService: CourseContentService,
    private pdfGeneratorService: PdfGeneratorService,
    private plRouter: PlRouter,
  ) {
    super(controlDir, courseContentService);
  }

  protected override initForm(): void {}

  protected override patchFormWithEmptyValue(): void {}

  protected override patchFormFromBlock(block: BlockButton): void {
    if (block.data.config?.hideIfStepIsCompleted && this.courseContentService.isCurrentStepCompleted()) {
      this.hideBlock();
    }

    this.buttonVariant = this.getButtonVariantFromColor(block.data.color);
  }

  private getButtonVariantFromColor(buttonColor: ButtonColor | string | null): ButtonVariant {
    switch (buttonColor) {
      case ButtonColor.alert:
        return ButtonVariant.red;
      case ButtonColor.primary:
        return ButtonVariant.blue;
      case ButtonColor.success:
        return ButtonVariant.green;
      case ButtonColor.tangerine:
        return ButtonVariant.orange;
      default:
        return ButtonVariant.blue;
    }
  }

  public async onButtonClick(event: MouseEvent): Promise<void> {
    if (this.manuallyDisableButton) {
      return;
    }

    if (!this.block?.data.href) {
      throw new Error(`Missing Href for button`);
    }

    switch (this.block?.data.type) {
      case ButtonType.link:
        window.open(this.block.data.href, '_blank');
        return;
      case ButtonType.state:
        this.plRouter.navigate([this.block.data.href], undefined, event);
        return;
      case ButtonType.pdf:
        this.manuallyDisableButton = true;
        await this.pdfGeneratorService.generateAndDownloadPdf(this.block.data.href);
        this.manuallyDisableButton = false;
        return;
      default:
        throw new Error(`Unknown buttonType: ${this.block?.data.type}`);
    }
  }
}
